import { APIMethod, fetchData } from "@client";

export async function resetPasswordQuery(data) {
  const res = await fetchData("/user/password", APIMethod.POST, { data });
  return res.success;
}
